var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticStyle:{"margin-left":"5px"},attrs:{"disabled":_vm.busy,"loading":_vm.busy,"plain":"","el-icon-right":"","icon":"el-icon-copy-document","type":"info","size":"mini"},on:{"click":_vm.copy}},[_vm._v("Copy URL "),_c('input',{attrs:{"id":"webpage-editor-copy-url-input","type":"hidden"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }